

<div *ngIf="paymentDone" >
  <!-- <div class="urlDiv" fxLayout="row wrap">
    <a class="urls" href="userProfiles/home/{{userId}}">
      Home /
    </a>

    <a  class="urls" href="/contest/all-contest">
      &nbsp;contests /
   </a>
   <a  class="urls" href="/contest/drawings">
       &nbsp;Drawings /
    </a>
    <a  class="urls" href="/contest/drawings/{{getId}}">
      &nbsp;{{title}}
   </a>
    </div> -->
  <div class="hitmaker_image_new" fxLayout="column wrap">
      <img class="image1"   [src]="drawingBannerUrl" >

  </div>   
  <div class="container-fluid">
    <p *ngIf="!winners || winners.length === 0"class="engageTitle"><strong> What you do</strong></p> <br>
    <p  *ngIf="!winners || winners.length === 0" class="newPara" [innerHTML]="smallDesc"></p>


<p class="engageTitle1"><strong>{{title}}</strong></p> <br>
<p class="newPara1">
   <span> {{largeDesc}} </span>
</p>
   <div *ngIf="!winners || winners.length === 0" style="margin-left: 4%;">
  <ul>
      <img class="image" style="height: auto;
      width: 4vw; margin-bottom: 0% !important"  src="assets\images\contest\list1.PNG" >
      <span style="font-size: 18px;font-family: Lato;">
          Prize 1 - {{prize1Desc}}
      </span>
  </ul>

  <ul>
      <img class="image"  style="height: auto;
      width: 4vw; margin-bottom: 0% !important"  src="assets\images\contest\list2.PNG" >
      <span style="font-size: 18px;font-family: Lato;">
          Prize 2 -  {{prize2Desc}}
      </span>
  </ul>
 
  <ul>
      <img class="image"  style="height: auto;
      width: 4vw; margin-bottom: 0% !important"  src="assets\images\contest\list3.PNG" >
      <span style="font-size: 18px;font-family: Lato;">
          Prize 3 -  {{prize3Desc}}
      </span>
  </ul>
</div> 
<div *ngIf="!winners || winners.length === 0" class="rectangle" fxLayout="row wrap">

    
  
  <div class="line top" fxLayout="row wrap">
      <p class="engageTitleRect"><strong>Purchase Tickets Using Creatics Currency</strong></p><br>
      <hr style="width: 60vw; margin-left: 5%;margin-right: 5%;">
      <div style="margin-left: 5%;font-size: 18px;font-family: Lato;" fxLayout="row wrap">
        <div>
          <button class="buyBtn"  data-bs-target="#myModal" fxLayout="row wrap"
    data-bs-toggle="modal"[disabled]="currency == 0 || startMin == 0" (click)="getPoints()">BUY</button>
        </div>
       <p>Creatics Currency Balance: {{currency}} </p>
       <p>Cost of 1 Drawing Ticket: {{ticketPrice}}</p>
       <p>Enter the Number of Tickets to Purchase: 
         <span><input type="number" type="number" min="0" max="30" step="1" pattern="[0-1]" placeholder="1"
          id="start" [value]="startMin" [(ngModel)]="startMin"  required>
         </span>  
       </p>
    
  </div>
 
 </div> 
</div>
<div *ngIf="tickets || tickets.length === 0" class="carousel" style="width: 90vw;" >

  <div style="margin-top: 5%;margin-bottom: 5%;">

  <owl-carousel-o [options]="carouselOptions">

      <ng-container *ngFor="let ticket of tickets">

      <ng-template carouselSlide>
        <h3 *ngIf="tickets || tickets.length === 0" style="color:black;font-family: 'Lato';justify-content: center;display: flex;">YOUR TICKETS PURCHASED</h3>

            <p style="color:black;font-family: 'Lato';justify-content: center;display: flex;"*ngIf="tickets">CREATICS</p>
              <p style="color:black;font-family: 'Lato';justify-content: center;display: flex;"*ngIf="tickets">{{ticket}}</p>         
      </ng-template>
  </ng-container>
    </owl-carousel-o>
  </div>
</div>
<div *ngIf="winners || winners.length === 0" class="carousel">

  <div >

  <owl-carousel-o [options]="carouselOptions">
      <ng-container *ngFor="let winner of winners">
      <ng-template carouselSlide>

          <a href="/">
              <img src="{{winner.customerImageUrl}}" [alt]="" [title]="">
              <span style="color:black;font-family: 'Lato';justify-content: center;display: flex;"*ngIf="winner.rank == '1'">Prize 1</span>
              <span style="color:black;font-family: 'Lato';justify-content: center;display: flex;" *ngIf="winner.rank == '2'">Prize 2</span>
              <span style="color:black;font-family: 'Lato';justify-content: center;display: flex;" *ngIf="winner.rank == '3'">Prize 3</span>

              <p style="color:black;font-family: 'Lato';justify-content: center;display: flex;">{{winner.fullName}}</p>
          </a>
      </ng-template>
  </ng-container>
    </owl-carousel-o>
  </div>
</div> 


<div class="recommend">
  <h2>OUR RECOMMENDATIONS</h2>
  <div class="recommend-data">
    <div
      class="img-recomend" fxLayout="row wrap"
      *ngFor="let item of images; let i=index"
      fxFlex.sm="0 1 calc(50%-10px)"
      fxFlex.md="0 1 calc(33%-10px)"
      fxFlex.gt-md="0 1 calc(25%-10px)"
    >

      <img  *ngIf="i<3" src="{{ item.imageUrl }}" style="width: 25vw;" /><br />
      <span  *ngIf="i<3"class="className">{{ item.name }}</span>
    </div>
  </div>
</div>
   
 
  <!-- <div style="display:flex;justify-content: center;">
      <img class="image" style="height:auto;width:70vw"  src="assets\images\contest\ss2.PNG" >

  </div> -->
</div>
</div>

 <!-- Contestant add button modal -->
 <div class="modal" id="myModal">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content" style="background-color: #fff !important;">


      <div class="modal-header">
        
        <button type="button" class="btn-close" style="background-color: #f58220;color:white"
          data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body">
        <!-- <span style="display:none" *ngFor="let moviesList of movieListTitles"></span> -->



          <div fxLayout="column wrap" fxLayoutGap="15px">
            <div fxLayout="row wrap">
               <p>

            </div>
            <div fxLayout="row wrap">
              <p class="descriptiontxt" name="description" cols="10" rows="10" id=""
                required fxFlex.md="100">
                Minimum Amount of Currency needed to buy drawing tickets: {{ticketPrice}}
                </p>
                <p class="descriptiontxt" name="description" cols="10" rows="10" id=""
                required fxFlex.md="100">
                Available Creatics Currency: {{currency}}
                </p>
            </div>
         
          

            <hr>

            <hr>

          </div>
     
        <button class="submit" style="width: auto; 
        float: left;
        margin-left: 30%;
        padding:15px !important"  type="submit" data-bs-dismiss="modal"  (click)="onPay()"> Pay {{startMin*ticketPrice}} Currency</button>

<button class="submit" style="background-color: white;color:black" data-bs-dismiss="modal">Cancel</button>

      </div>
    </div>
  </div>
</div>
<div *ngIf="!paymentDone" style="display: flex;flex-direction: column;
flex-wrap: nowrap;
align-content: center;
justify-content: center;
align-items: flex-start;
padding: 5% 0% 5% 10%;
font-family: 'Lato';">

  <h3 style="font-family: 'Lato';font-size:24px;font-weight: 600;">Payment Receipt</h3>

  <p style="font-family: 'Lato';">Thank you very much for your interest in Creatics! We would like to thank you for purchasing Raffel Tickets.</p>
  <p style="font-family: 'Lato';">Status: Successful</p>
 <p style="font-family: 'Lato';"> Date  {{jstoday }}</p>  
 <p style="font-family: 'Lato';">Status: Successful</p>

<p style="font-family: 'Lato';">Payment Type: Creatics Currency</p>
<p style="font-family: 'Lato';"> Amount: {{startMin*ticketPrice}}</p>
<p style="font-family: 'Lato';">Creatics Currency Spent:  {{startMin*ticketPrice}}</p>
<p style="font-family: 'Lato';">Transaction ID: NA</p>
<a style="font-family: 'Lato';" href="userProfiles/home/{{userId}}">Return to Creatics site</a>
</div> 